import React from 'react';
import { Text, Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../../i18n';

export const NewBriefAndMatchTitle = () => (
    <>
        <Typography
            as="h1"
            color="heading"
            marginBottom="4"
            size={{
                default: 'h_xl',
                md: 'h_md',
            }}
        >
            {appTranslate('identification.banner.new_brief_and_match.title', {
                templates: {
                    accent: (text?: string) => (
                        <Typography as="span" color="orange_700">
                            {text}
                        </Typography>
                    ),
                },
            })}
        </Typography>
        <Text>{appTranslate('identification.banner.new_brief_and_match.subtitle')}</Text>
    </>
);
